import type { AskCancelOutput, TripOutput } from '@allocab/allocab-passenger-shared-types';

import { PrimaryButton } from '../../../components/button/PrimaryButton';
import { SecondaryButton } from '../../../components/button/SecondaryButton';
import { ModalTitle } from '../../../components/Modal';
import { t } from '../../../services/translation/translation';
import { formatPrice } from '../../../utils/trip';

const useDescription = (trip: TripOutput, cancelRequest: AskCancelOutput) => {
  const amount = formatPrice(Math.abs(cancelRequest.amountToRefundWithTax), trip.resume.price.currency);

  if (cancelRequest.amountToRefundWithTax < 0) {
    return t('cancel-modal.fees', { fees: amount });
  }

  const isFree = cancelRequest.amountToRefundWithTax === trip.resume.price.amountWithTax;

  const prefix = isFree ? `${t('cancel-modal.free-cancellation')}` : '';

  if (trip.tripVars.displayPrice && cancelRequest.amountToRefundWithTax > 0) {
    return `${prefix}${t('cancel-modal.refund', { refund: amount })}`;
  } else {
    return t('cancel-modal.no-display-price');
  }
};

type Props = {
  trip: TripOutput;
  cancelRequest: AskCancelOutput;
  onConfirm: () => void;
  onCancel: () => void;
};

export const AskStep = ({ trip, cancelRequest, onCancel, onConfirm }: Props) => {
  const description = useDescription(trip, cancelRequest);

  return (
    <>
      <ModalTitle title={t('cancel-modal.title')} />
      <p className="text-center my-4">{description}</p>
      <div className="flex flex-row space-x-2">
        <SecondaryButton onClick={onCancel} className="flex-1">
          {t('common.no')}
        </SecondaryButton>
        <PrimaryButton onClick={onConfirm} className="flex-1">
          {t('common.yes')}
        </PrimaryButton>
      </div>
    </>
  );
};
